import React, { useEffect, useState } from "react";
import SubscriptionFooter from "./SubscriptionFooter";
import "./VerifiedPaymentSubscriptionPlan.css";
import "../../../sharedPages/NewCopyTrade/ExchangeConnection/ExchangeConnection.css";
import CheckIcon from "../../../../assets/images/greenCheck.svg";
import discountIcon from "../../../../assets/images/verifyTrades/discountIcon.svg";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { storeUser } from "../../../../redux/users/usersSlice";
import { Modal, Button } from "react-bootstrap";
import cross from "../../../../assets/images/cross.svg";
import tradeBellPng from "../../../../assets/images/bellIcon.svg";
import { fetchUser } from "../../../../helpers/helper";

const VerifiedPaymentSubscriptionPlan = ({
  activeButton,
  setActiveButton,
  setClientSecret,
}) => {
  const subscriptionMonthlyPlans = [
    {
      title: "Verify Monthly",
      description:
        "Calculated, updated and stored on the blockchain every month",
      price: "9.95",
      frequency: "monthly",
      features: [
        "Performance stored on-chain monthly",
        "Verifiable on website",
        "Auto-shared to social",
        "24/7 Support",
      ],
      planType: "monthly-blockchain-monthly",
    },
    {
      title: "Verify Daily",
      description: "Calculated, updated and stored on the blockchain every day",
      price: "19.95",
      frequency: "daily",
      features: [
        "Performance stored on-chain daily",
        "Verifiable on website",
        "Auto-shared to social",
        "24/7 Support",
      ],
      planType: "monthly-blockchain-daily",
    },
  ];
  const subscriptionYearlyPlans = [
    {
      title: "Verify Monthly",
      description:
        "Calculated, updated and stored on the blockchain every month",
      price: "99.95",
      frequency: "monthly",
      planType: "yearly-blockchain-monthly",
      features: [
        "Performance stored on-chain monthly",
        "Verifiable on website",
        "Auto-shared to social",
        "24/7 Support",
      ],
    },
    {
      title: "Verify Daily",
      description: "Calculated, updated and stored on the blockchain every day",
      price: "199.95",
      frequency: "daily",
      planType: "yearly-blockchain-daily",
      features: [
        "Performance stored on-chain daily",
        "Verifiable on website",
        "Auto-shared to social",
        "24/7 Support",
      ],
    },
  ];

  const user = useSelector((state) => state?.user?.user);

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  // const [paymentLoading, setPaymentLoading] = useState(false);
  // State for confirmation modal
  const [showConfirmation, setShowConfirmation] = useState({
    show: false,
    action: "", // "Cancel", "Upgrade", "Downgrade", "Subscribe"
  });
  const [paymentprocessing, setPaymentprocessing] = useState(false);
  const [pendingPlan, setPendingPlan] = useState(null);

  const api = useApi();

  const dispatch = useDispatch();

  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );

  useEffect(() => {
    setSelectedPlan(null);
    const subscription = user?.verifiedmyTrade?.subscription;
    if (subscription?.active && subscription.originalName) {
      const match = plans.find(
        (plan) => plan.planType === subscription.originalName
      );
      if (match) {
        setSelectedPlan(match);
      }
    }
  }, [activeButton, user]);

  // Get current pricing options based on active button
  const plans =
    activeButton === "Monthly"
      ? subscriptionMonthlyPlans
      : subscriptionYearlyPlans;

  // Button text
  const buttonText = selectedPlan
    ? `Pay ${selectedPlan.price}`
    : "Select a plan";

  // Handle payment - show confirmation popup first
  const handlePay = (selectedPlanPro) => {
    setSelectedPlan(selectedPlanPro);
    setPendingPlan(selectedPlanPro);
    // Determine if it's upgrade or downgrade
    const subscription = user?.verifiedmyTrade?.subscription;
    const hasActiveSubscription =
      subscription?.active && subscription.originalName && !subscription.scheduledForCancellation;
    const allPlans = [...subscriptionMonthlyPlans, ...subscriptionYearlyPlans];
    const currentSubscribedPlan = allPlans.find(
      (plan) => hasActiveSubscription && plan.planType === subscription.originalName
    );
    const action = currentSubscribedPlan
      ? (Number(selectedPlanPro.price) > Number(currentSubscribedPlan.price) ? "Upgrade" : "Downgrade")
      : "Subscribe";
    setShowConfirmation({
      show: true,
      action: action,
    });
  };

  // Handle actual payment/upgrade/downgrade/reactivate after confirmation
  const handleConfirmAction = async () => {
    if (showConfirmation.action === "Cancel") {
      await handleConfirmCancel();
      return;
    }

    if (showConfirmation.action === "Reactivate") {
      await handleReactivate();
      return;
    }

    if (!pendingPlan) return;
    
    setLoading(true);
    
    try {
      const res = await api("post", "users/verifyTradePaymentSubscription", {
        planType: pendingPlan.planType,
      });
      if (res?.status && res?.data?.clientSecret) {
        setClientSecret(res.data.clientSecret);
      } 
      await fetchUser(api, dispatch, storeUser);
      // showNotificationToast("Subscription upgraded!", "Performance is now being updated more frequently on-chain.");
      // else {
      //   toastify(res?.message || "Failed to create session");
      // }
    } catch (error) {
      console.error("Error:", error);
      toastify("Payment failed. Please try again.");
    }
    setLoading(false);
    setPaymentprocessing(false);
    setPendingPlan(null);
    setShowConfirmation({ show: false, action: "" });
  };

  // Handle reactivation after confirmation
  const handleReactivate = async () => {
    const subscription = user?.verifiedmyTrade?.subscription;
    if (!subscription?.originalName) {
      toastify("Unable to reactivate subscription");
      setShowConfirmation({ show: false, action: "" });
      return;
    }
    
    setLoading(true);
    try {
      const res = await api("post", "users/verifyTradePaymentSubscription", {
        planType: subscription.originalName,
      });
      if (res?.status) {
        await getUser();
        // toastify("Subscription reactivated successfully.", "success");
        setSelectedPlan(null);
      } else {
        toastify(res?.message || "Failed to reactivate subscription");
      }
    } catch (error) {
      console.error("Error:", error);
      toastify("Failed to reactivate subscription");
    }
    setLoading(false);
    setPaymentprocessing(false);
    setPendingPlan(null);
    setShowConfirmation({ show: false, action: "" });
  };

  async function getUser() {
    try {
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        setActiveButton(
          data?.user?.verifiedmyTrade?.subscription?.planType === "year" &&
            data?.user?.verifiedmyTrade?.subscription?.status === "active"
            ? "Yearly"
            : "Monthly"
        );
        if (data?.token) localStorage.setItem("token", data.token);
      }
    } catch (err) {
      console.log(err.message);
    }
  }
  const allPlans=[...subscriptionMonthlyPlans, ...subscriptionYearlyPlans];
  // Mark plan as subscribed if it matches the user's active subscription
  const subscription = user?.verifiedmyTrade?.subscription;
  const hasActiveSubscription =
    subscription?.active && subscription.originalName;
  const plansWithSubscribed = plans.map((plan) => {
    if (hasActiveSubscription && plan.planType === subscription.originalName) {
      return { ...plan, subscribed: true,scheduledForCancellation: subscription.scheduledForCancellation };
    }
    return plan;
  });
  const subscribedPlan = allPlans.find((plan) => hasActiveSubscription && plan.planType === subscription.originalName);
  // Handle showing cancel/reactivate confirmation
  const handleCancelClick = (plan) => {
    const action = plan?.scheduledForCancellation ? "Reactivate" : "Cancel";
    setShowConfirmation({
      show: true,
      action: action,
    });
  };

  // Handle actual cancellation after confirmation
  const handleConfirmCancel = async () => {
    setCancelLoading(true);
    try {
      const res = await api("post", "users/cancelBlockchainSubscription");
      if (res?.status) {
        await getUser();
        showNotificationToast("You've unsubscribed!", "Verification has been paused.");
        // toastify("Subscription cancelled.", "success");
        setSelectedPlan(null);
      } else {
        toastify(res?.message || "Failed to cancel subscription");
      }
    } catch (error) {
      toastify("Failed to cancel subscription");
    }
    setPaymentprocessing(false);
    setCancelLoading(false);
    setShowConfirmation({ show: false, action: "" });
  };

  // Handle modal close
  const handleModalClose = () => {
    setShowConfirmation({ show: false, action: "" });
    setPendingPlan(null);
  };

  const boldDailyMonthly = (text) => {
    const highlighted = text
      .replace(/\bdaily\b/gi, "<strong>daily</strong>")
      .replace(/\bmonthly\b/gi, "<strong>monthly</strong>");
    return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
  };

  return (
    <div className="VerifiedPaymentSubscriptionPlan">
      <div className="switchSide p-0">
        <div className="switchBase">
          <button
            className={`${activeButton === "Monthly" ? "active" : ""}`}
            onClick={() => setActiveButton("Monthly")}
          >
            Monthly
          </button>
          <button
            className={`${activeButton === "Yearly" ? "active" : ""}`}
            onClick={() => setActiveButton("Yearly")}
          >
            Yearly
          </button>
        </div>
      </div>
      <div className="subscriptionPlansCardBox">
        {plansWithSubscribed.map((plan, index) => (
          <div
            key={index}
            className="card verifiedPaymentCard"
            style={{
              borderColor: `${plan.subscribed ? "#11B700" : "transparent"}`,
            }}
          >
            {plan.subscribed && (
              <div className="subscribedTextWrap">
                <p>Subscribed</p>
              </div>
            )}
            <h4 className="title">
              {plan.title}
              {activeButton === "Yearly" && (
                <span className="verifiedCardSavingPrice d-inline-flex align-items-center">
                  <img src={discountIcon} alt="Visa Verified" />
                  <span className="savingText">2 months discount</span>
                </span>
              )}
            </h4>
            <p className="desc">{plan.description}</p>

            <h6 className="paymentValue">
              ${plan.price}
              <span className="timeValue"> / month</span>
            </h6>

            <ul className="infoList">
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <span className="checkmark">
                    <img src={CheckIcon} alt="CheckIcon" />
                  </span>
                  {boldDailyMonthly(feature)}
                </li>
              ))}
            </ul>

            <div className="selectPaymentBtnBox">
              <BubbleSvgButton
                // isLoading={paymentprocessing}
                disabled={paymentprocessing}
                text={plan.subscribed ? plan.scheduledForCancellation ? "Reactivate" : "Cancel" :`${subscribedPlan?Number(plan.price)>Number(subscribedPlan.price) ? "Upgrade" : "Downgrade": "Select"}`}
                type="button"
                variant={`${plan.subscribed ?  "red" : "black"}`}
                className="btnPaymentSelect"
                containerStyling={{
                  justifyContent: "center",
                  height: "38px",
                }}
                onClick={() => {
                  if (plan.subscribed) {
                    handleCancelClick(plan);
                    return;
                  }
                  console.log("dfdfsdfsfd");
                  handlePay(plan);
                }}
                mainDivStyle={{
                  height: "38px",
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <SubscriptionFooter />
      {/* Confirmation Modal */}
      <Modal backdrop="false" id="verificationApiModal" show={showConfirmation.show}>
        <Modal.Body>
          <div className="modalContent">
            <Button className="closeBtn" onClick={handleModalClose}>
              <img alt="Close Modal" src={cross} />
            </Button>
            <div className="regBox" style={{ gap: "13px" }}>
              <div className="img-box">
                <img
                  alt="Confirmation"
                  src={tradeBellPng}
                  className="bellIconSvg"
                />
              </div>
              <div className="content-box">
                <p className="popUpMsg">
                  {showConfirmation.action === "Cancel"
                    ? "Cancel your subscription?"
                    : showConfirmation.action === "Reactivate"
                    ? "Reactivate your subscription?"
                    : showConfirmation.action === "Upgrade"
                    ? "Upgrade your subscription?"
                    : showConfirmation.action === "Downgrade"
                    ? "Downgrade your subscription?"
                    : "Subscribe to this plan?"}
                  <br />
                  {showConfirmation.action === "Cancel" && (
                    <span>Copy trading will be interrupted.</span>
                  )}
                  {showConfirmation.action === "Reactivate" && (
                    <span>Your subscription will continue as normal.</span>
                  )}
                  {/* {(showConfirmation.action === "Upgrade" ||
                    showConfirmation.action === "Downgrade" ||
                    showConfirmation.action === "Subscribe") && (
                    <span>Your plan will be updated at the start of your next billing period.</span>
                  )} */}
                    {showConfirmation.action === "Downgrade" && (
                    <span>Your plan will be updated at the start of your next billing period.</span>
                  )}
                  {showConfirmation.action === "Upgrade" && (
                    <span>Your plan updates immediately, with a credit for your current monthly payment.</span>
                  )}
                  {showConfirmation.action === "Subscribe" && (
                    <span>Your subscription will be updated accordingly.</span>
                  )}
                </p>
              </div>
            </div>
            <div className="payoutButtonBox">
              <BubbleSvgButton
                className="payoutModalBtn"
                mainDivStyle={{ width: "126px", height: "36px" }}
                text={"Continue"}
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
                onClick={async()=>{
                  setShowConfirmation({ show: false, action: "" });
                  setPaymentprocessing(true);
                  await handleConfirmAction();
                }}
              />
              <BubbleSvgButton
                className="payoutModalBtn"
                mainDivStyle={{ width: "126px", height: "36px" }}
                text={"Cancel"}
                type="button"
                variant="red"
                containerStyling={{
                  justifyContent: "center",
                }}
                onClick={handleModalClose}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerifiedPaymentSubscriptionPlan;
